import React from 'react';

import Rond from "./Rond";
import Check from "./Check";
import Reporte from "./Reporte";

const iconMapping = {
    'Rond': Rond,
    'Check': Check,
    'Reporte': Reporte,
    // Ajoutez d'autres mappings ici
};

const IconeStatut = ({icone, couleur}) => {
    const IconComponent = iconMapping[icone] || null;
    return IconComponent ? <IconComponent couleur={couleur}/> : null;
};

export default IconeStatut;
